import { Box, Skeleton, Stack, Typography } from '@mui/material';
import { Link, useLocation } from '@tanstack/react-router';
import Logo from 'assets/icons/general/logo.svg?react';
import { RoutePaths } from 'common-types';
import { isNavLinkActive, pagesData } from 'data/navigation';
import { useGetUserData } from 'hooks/use-get-user-data';
import { FC, memo } from 'react';
import { useAnalytics } from 'services/analytics';
import { useStore } from 'store';
import { useShallow } from 'zustand/react/shallow';

import DefaultAvatar from '../drawer/assets/default-avatar.png';
import {
  avatarLinkContainerSx,
  avatarSx,
  headerLogoContainerSx,
  headerSx,
  navIndicatorSx,
  navLinksContainerSx,
  navLinkSx,
  navLinkTextSx,
} from './styles';

export const HeaderDesktop: FC = memo(() => {
  const { trackEvent } = useAnalytics();
  const location = useLocation();
  const { isSuccess, userPhoto } = useGetUserData();
  const { photo } = useStore(useShallow((state) => ({ photo: state.photo })));

  const handleNavClick = (screenName: string) => (): void => {
    if (location.pathname === RoutePaths.HOME && screenName) {
      trackEvent('home_screen_button_tap', { button: screenName.toLowerCase() });
    }
  };

  const avatarSrc = userPhoto || photo || DefaultAvatar;

  return (
    <Stack direction="row" component="header" sx={headerSx}>
      <Stack component={Link} to={RoutePaths.HOME} direction="row" sx={headerLogoContainerSx}>
        <Logo width={95} />
      </Stack>

      <Stack component="nav" direction="row" alignItems="center" justifyContent="center" sx={navLinksContainerSx}>
        {pagesData.map(({ title, href }) => {
          const isActive = isNavLinkActive(location.pathname, href);

          return (
            <Box key={title} component={Link} to={href} onClick={handleNavClick(title)} sx={navLinkSx(isActive)}>
              <Typography sx={navLinkTextSx}>{title}</Typography>
              <Box sx={navIndicatorSx(isActive)} />
            </Box>
          );
        })}
      </Stack>

      <Stack direction="row" component={Link} to={RoutePaths.PROFILE} sx={avatarLinkContainerSx}>
        {isSuccess ? (
          <Box component="img" src={avatarSrc} alt="avatar" sx={avatarSx} />
        ) : (
          <Skeleton variant="circular" width={40} height={40} />
        )}
      </Stack>
    </Stack>
  );
});
